module.exports = __webpack_public_path__ + "assets/img/AI投顾辅助.10fb965e.png";